import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Tree } from 'antd'
import { useHistories } from '../../../../hooks'
import useQuery from '../../../../hooks/useQuery'
import { ROUTES_NAME } from '../../../../constants'
import { Wrapper } from './styled'

export const TaskCategoryTree = ({ taskCategoryList, taskTypeId }) => {
  const history = useHistories()
  const query = useQuery()
  const taskCategoryId = query.get('taskCategoryId')
  const [selectedKeys, setSelectedKeys] = useState([])

  useEffect(() => {
    setSelectedKeys(taskCategoryId ? [Number(taskCategoryId)] : [])
  }, [taskCategoryId])

  return (
    <Wrapper>
      <Tree
        treeData={taskCategoryList}
        selectedKeys={selectedKeys}
        defaultExpandAll
        showLine
        style={{
          marginTop: 16,
          paddingBottom: 16
        }}
        onSelect={(keys) => {
          const key = keys.length > 0 ? keys[0] : selectedKeys.length > 0 ? selectedKeys[0] : null
          if (!key) return
          history.push(`${ROUTES_NAME.TASK}?taskTypeId=${taskTypeId}&taskCategoryId=${key}`)
        }}
      />
    </Wrapper>
  )
}

TaskCategoryTree.propTypes = {
  taskCategoryList: PropTypes.array,
  taskTypeId: PropTypes.number
}
